import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormArray, Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductDao } from '@app/dao/product/product.dao';
import { CommandEnum } from '@app/forms/subscription/definition/interface/enum';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'credit-additionnal-informations',
    templateUrl: './credit-additionnal-informations.component.html',
    styleUrls: ['./credit-additionnal-informations.component.scss'],
    standalone: false
})
export class CreditAdditionnalInformationsComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionsOccupationRisk: any[] = [];
  optionsSportRisk: any[] = [];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private productDao: ProductDao,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    const productCode = pledge?.products?.[0]?.parameters.choosedProductCode;
    this.productDao.getDigitalInsureProduct(productCode).subscribe(product => {
      const ownerAdditionnalDetailsArray = this.ownerAdditionnalDetails;

      if (product?.occupationRisk?.length) {
        this.optionsOccupationRisk = product.occupationRisk;
      }

      if (product?.sportRisk?.length) {
        this.optionsSportRisk = product.sportRisk;
      }

      ownerAdditionnalDetailsArray.controls.forEach((detailControl, index) => {
        // Traitement des risques liés à l'occupation
        const existingOccupationRiskDetail = detailControl.get(
          'occupationRiskDetail',
        ).value;
        if (existingOccupationRiskDetail) {
          const foundOccupationRisk = this.optionsOccupationRisk.find(
            item => item.id === existingOccupationRiskDetail,
          );

          if (!foundOccupationRisk) {
            detailControl.get('occupationRiskDetail').setValue(null);
          }
        }
        detailControl
          .get('occupationRiskDetail')
          .setValidators(Validators.required);
        detailControl.get('occupationRiskDetail').updateValueAndValidity();

        // Traitement des risques liés aux sports
        const existingSportRiskDetail =
          detailControl.get('sportRiskDetail').value;
        if (existingSportRiskDetail) {
          const foundSportRisk = this.optionsSportRisk.find(
            item => item.id === existingSportRiskDetail,
          );

          if (!foundSportRisk) {
            detailControl.get('sportRiskDetail').setValue(null);
          }
        }
        detailControl.get('sportRiskDetail').setValidators(Validators.required);
        detailControl.get('sportRiskDetail').updateValueAndValidity();
      });

      if (!product?.occupationRisk?.length) {
        ownerAdditionnalDetailsArray.controls.forEach(control => {
          control.get('occupationRiskDetail').setValue(null);
          control.get('occupationRiskDetail').clearValidators();
          control.get('occupationRiskDetail').updateValueAndValidity();
        });
      }

      if (!product?.sportRisk?.length) {
        ownerAdditionnalDetailsArray.controls.forEach(control => {
          control.get('sportRiskDetail').setValue(null);
          control.get('sportRiskDetail').clearValidators();
          control.get('sportRiskDetail').updateValueAndValidity();
        });
      }
    });

    this.subscriptionFacade.initForm(this);
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.setCommand([
      CommandEnum.CHOOSE_PRODUCT_BORROWER_INSURANCE,
    ]);
    this.subscriptionFacade.submitPledge(this);
  }

  get ownerAdditionnalDetails(): UntypedFormArray {
    return this.form
      .get('products')
      .get('0')
      .get('parameters')
      .get('ownerAdditionnalDetails') as UntypedFormArray;
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
